import React from "react";
import Banner from "../../components/Widgets/Banner";

const About = () => {
    return (
        <div className="about">
            <Banner route="about us">

            </Banner>
        </div>
    )
}

export default About;